import { render, staticRenderFns } from "./ExceedanceDescriptions.vue?vue&type=template&id=1df30440&"
import script from "./ExceedanceDescriptions.vue?vue&type=script&lang=js&"
export * from "./ExceedanceDescriptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports